import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getMissionActivationTimeAction = createAsyncThunk(
    'get-mission-time',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-mission-active-time`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMissionActivationTimeSlice = createSlice({
    name: 'get-mission-time',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMissionActivationTimeAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getMissionActivationTimeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getMissionActivationTimeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getMissionActivationTimeReducer = getMissionActivationTimeSlice.reducer